import styled from 'styled-components';

export const CommunityContextListItemButton = styled.button`
  display: flex;
  border: none;
  outline: none !important;
  cursor: pointer;
  margin: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  text-transform: none;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.2;
  min-height: 44px;

  // Corrects font smoothing for webkit
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  // Corrects inability to style clickable input types in iOS
  -webkit-appearance: none;

  font-size: 16px;
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
  width: 100%;
  padding: 11px 16px;
  text-align: left;
  justify-content: space-between;
  &:hover {
    background-color: #d4d4d4;
  }
`;

export default CommunityContextListItemButton;
